import React, { Fragment, useEffect, useState } from 'react'
import { pagingSystemConfig, getFileDescription } from "../services/PublicService";
import localStorageService from "../services/localStorageService";
import { updateAppConfig } from "../services/jwtAuthService";
import { SOLUTION_DEFAULT } from '../common/LocalConst';

function isNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

export default function Public({children}) {
  const [renderChildren, setRenderChildren] = useState(false);
  const getSystemConfig = async () => {
    const { data } = await pagingSystemConfig({ pageIndex: 1, pageSize: 1000 });
    if (data?.content?.length > 0) {
      let dataLocal = {};
      for (let item of data.content) {
        let value = item.configValue;
        if (value === "true") {
          value = true;
        }
        if (value === "false") {
          value = false;
        }
        if (isNumber(value)) {
          value = +value;
        }

        if (item.configKey === "LOGO" && item?.configValue) {
          try {
            await getFileDescription(item?.configValue).then(({ data }) => {
              localStorageService.setItem("imgLogo", URL.createObjectURL(data));
            })
          }
          catch (err) {
            console.error(err)
          }
        }
        if (item?.configKey === "SOLUTION") {
          value = localStorageService.parseJson(value, SOLUTION_DEFAULT)
        }

        dataLocal[item.configKey] = value;
      }
      localStorageService.setItem("sysConfig", dataLocal);
      updateAppConfig(localStorageService.getItem("sysConfig"));
      setRenderChildren(true)
    }
  }

  useEffect(() => {
    getSystemConfig();
  }, [])
  if (renderChildren) return <Fragment>{children}</Fragment>;
  return <></>;
}
